import React from 'react';
import { getFamilyMissingFields } from './ModalCheckMissingField';

// Page-level validation for family pages (Parent No.1, Parent No.2, Legal Guardian).
// Uses the same rules as the "check missing values" modal so the list and the red
// highlight always agree. Auto-save is not blocked; only Save / Continue / Reviewed are.
export const useFamilyRequiredValidation = (
  page: string,
  check: string | null,
  getData: () => any,
  openMissingFieldsModal: () => void
) => {
  // Turns on the red "missing" highlight after a failed validation.
  const [showValidation, setShowValidation] = React.useState(false);

  // Highlight missing required fields when opened with ?check=1 or after a failed validation.
  const showMissing = check || (showValidation ? '1' : null);

  // Returns true when every visible required (*) field is filled; otherwise highlights
  // the missing fields and opens the modal listing them.
  const validateRequiredFields = (): boolean => {
    const missingFields = getFamilyMissingFields(page, getData());
    if (missingFields.length > 0) {
      setShowValidation(true);
      openMissingFieldsModal();
      return false;
    }
    return true;
  };

  return { showMissing, validateRequiredFields };
};
